// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //baseApiIp : "http://172.16.0.212:9300/",
  //baseApiIp : "http://10.20.35.77:9700/",
  baseApiIp : "https://checkinapi.gobreeze.com/",
  //baseApiIpTalkPhr : "https://uat-webservices.mtbc.com/breezecheckinprelive/",
  baseApiIpTalkPhr : "https://mhealth.mtbc.com/breezecheckinapi/",
  //baseApiIpSymptoms : "http://172.16.14.213:6000/",
  baseApiIpSymptoms : "https://checkinapi.gobreeze.com/symptoms/",
  baseAPIOCR: 'https://insurances.gobreeze.com',
  baseAPIDrivingLicense: 'http://172.16.0.65:8000/api/getLicenseData',
  baseAPIOTP:'https://mhealth.mtbc.com/Notify/',
  // baseApiIpTalkPhr : "https://localhost:44373/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI
